import ContainerPage from "../../components/ContainerPage/ContainerPage";
import PageTitle from "../../components/PageTitle/PageTitle";
import React, { useState } from "react";
import GeneralTab from "../../components/EditCustomerGeneral/EditCustomerGeneral";
import ChangePasswordTab from "../../components/ChangePassword/ChangePassword";
import Tab from "../../components/Tab/Tab";
import { ChangePasswordIcon, ProfileIcon } from "../../components/Icons/Icons";
import { useNavigate } from "react-router-dom";


const EditCustomerPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('general');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <ContainerPage>
      <PageTitle title="Account" onBack={() => navigate(-1)} />
      <div className="mt-8 ">
        <div className="flex gap-10 mb-10">
          <Tab imgLink={<ProfileIcon fill={`${activeTab === "general" ? 'var(--color-gray-950)' : 'var(--color-gray-600)'}`} />}
            isActive={activeTab === "general"} onClick={() => handleTabChange('general')}>
            General
          </Tab>
          <Tab imgLink={<ChangePasswordIcon fill={`${activeTab === "changePassword" ? 'var(--color-gray-950)' : 'var(--color-gray-600)'}`} />}
            isActive={activeTab === "changePassword"} onClick={() => handleTabChange('changePassword')}>
            Change Password
          </Tab>
        </div>
        <div className="flex items-center justify-center">
          {activeTab === 'general' && <GeneralTab />}
          {activeTab === 'changePassword' && <ChangePasswordTab />}
        </div>

      </div>
    </ContainerPage>
  )
}

export default EditCustomerPage